<template>
  <div id="app">
    <div class="top-bg"></div>
    <div class="right-bg"></div>
    <div class="left-bg"></div>
    <div class="bottom"></div>
    <div class="bottom-bg"></div>
    <router-view />
<!--    <pipeline/>-->
    <valve/>
<!--    <Jar/>-->
   <!-- <Yellowpipeline/> -->
    <iframe src="./mms3D/index.html" frameborder="0" id="iframe"></iframe>
    <Vidoe/>

    <div class="gz-tc" v-for="(item,i) in popData" :key="i" :class="'box '+item" style="opacity:0;position: absolute;">
        <div class="close" style="position: absolute;height: 8px;right: 5px; cursor: pointer;">X</div>
        <div class="gz-gd">
            <p class="p">管道直径:219mm</p>
            <p class="p">管道壁厚:5mm</p>
            <p class="p">管道压力:76MPa</p>
            <p class="p">风险等级：低风险</p>
        </div>
    </div>
  </div>
 

</template>
<script lang="ts">
  //管道
  import pipeline from "./components/PopUps/pipeline.vue";
  //阀门弹窗
  import valve from "./components/PopUps/valve.vue";
  //罐子
  import Jar from "./components/PopUps/Jar.vue";
  //黄色管道
  import Vidoe from "./components/Video"
  // import {getPdi,getJ1,getWaring,getZo} from './api/index'
  import $ from "jquery";

export default {
  components:{
    pipeline,
    valve,
    Jar,
    Vidoe
  },
  data(){
    return{
      pt:[

        ],
      jData:[

      ],
      pdiData:[],
      fm:[],
      popData:['dixiaguanxx032','dixiaguanxx002'],
      type:false,
      ptShow:false,
      jShow:false,
      itemflag:false,
      flag1:true
    }
  },
  mounted(){
    window.ptShow1 = this.ptShow1;
    window.jShow1 = this.jShow1;
    window.ptHide = this.ptHide;
    window.jHide = this.jHide;
    window.getJzo =  this.getJzo;
    // window.getWar = this.getWar;
  },
  methods: {
    // async getData(path) {
    //   await getPdi(path, {
    //     _sort: '-time',
    //     _size: 1
    //   }).then((data) => {
    //     //打印获取接口的数据
    //     // console.log(data);

    //   }).catch((e) => {
    //     console.log(e);
    //   })
    // },
    // getWar(){
    //   getWaring({
    //     _sort: '-time',
    //     _size: 1
    //   }).then((data) => {
    //     //打印获取接口的数据
    //     // console.log(data);
    //     if(data.data[0].ZO==1){
    //       document.getElementById("iframe").contentWindow.openWaring();
    //     }
    //   }).catch((e) => {
    //     console.log(e);
    //   })
    // },
    jShow1() {
      this.jShow = true;
    },
    ptHide() {
      this.ptShow = false;
    },
    jHide() {
      this.jShow = false;
    },
    ptShow1(){
      this.ptShow = true;
    },

  }
};
</script>
<style>
  @font-face {
    font-family: VF;
    src: url('./assets/font/SOURCEHANSANSCN-VF.OTF');
  }
  .pt{
    opacity: 0;
  }
  .j{
    opacity: 0;
  }

#app{
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: #000;
}
*{
  margin: 0;
  padding: 0;
  font-size: 14px;
}
ul{
  list-style: none;
}
#iframe {
  width: 100%;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
}
  .top-bg{
    position: absolute;
    width: 100%;
    height: 19.46vh;
    background: linear-gradient(#03242e,rgba(0,0,0,0));;
    top: 0;
    left: 0;
    z-index:1;
    pointer-events: none;
  }
  .left-bg{
    width: 350px;
    height: 100vh;
    position: absolute;
    left: 0;
    top: 0;
    background: linear-gradient(to right,#03242e,rgba(0,0,0,0));
    z-index:1;
    pointer-events: none;
  }
 
.right-bg{
  width: 350px;
  height: 100vh;
  position: absolute;
  right: 0;
  top: 0;
  background: linear-gradient(to left,#03242e,rgba(0,0,0,0));
  z-index:1;
  pointer-events: none;
}
.bottom{
  position: absolute;
  width: 93.5vw;
  height: 21.7vh;
  bottom: 53px;
  left: 50%;
  transform: translateX(-50%);
  background: url("./assets/bottom.png") no-repeat;
  background-size: 100% 100%;
  z-index: 1;
  pointer-events: none;
}
  .bottom-bg{
    position: absolute;
    width: 100%;
    height: 19.46vh;
    background: linear-gradient(to top,#03242e,rgba(0,0,0,0));;
    bottom: 0;
    left: 0;
    z-index:1;
    pointer-events: none;
  }
</style>
